import { render, staticRenderFns } from "./SeparatedDoubleSlot.vue?vue&type=template&id=b953315c&scoped=true"
import script from "./SeparatedDoubleSlot.vue?vue&type=script&lang=ts"
export * from "./SeparatedDoubleSlot.vue?vue&type=script&lang=ts"
import style0 from "./SeparatedDoubleSlot.vue?vue&type=style&index=0&id=b953315c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b953315c",
  null
  
)

export default component.exports